import request from '@/utils/request'

const agentApi = {
    GetAgentInfo: '/agentApi/agent/getAgentInfo',
    UpdateAgentInfo: '/agentApi/agent/updateAgentInfo',
    ChangePassword: '/agentApi/agent/changePassword',
    Login: '/agentApi/agent/login',
    Logout:'/agentApi/agent/logout'
}

//获取代理商信息
export function getAgentInfo () {
    return request({
        url: agentApi.GetAgentInfo,
        method: 'get',
    })
}

//更新代理商信息
export function updateAgentInfo(parameter) {
    return request({
        url: agentApi.UpdateAgentInfo,
        method: 'post',
        data: parameter
    })
}

//修改密码
export function changePassword(parameter) {
    return request({
        url: agentApi.ChangePassword,
        method: 'post',
        data: parameter
    })
}

//登录
export function login (parameter) {
    return request({
        url: agentApi.Login,
        method: 'post',
        data: parameter
    })
}

//退出登录
export function logout(){
    return request({
        url: agentApi.Logout,
        method: 'post',
    })
}
  
